import React, { useState, useEffect, useMemo, useContext, useRef } from 'react';
import './AssesstmentForm.css';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import surveyDataTR from './surveyData';
import surveyDataEN from './surveyData_en';
import { ValuationContext } from '../../context/ValuationContext';
import { FiInfo } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { isDcfOnlyCompanyStage } from '../sectorOptions';


 
// Random cümle seçimi için yardımcı fonksiyon
const getRandomSentence = (sentences) => {
    if (!sentences || sentences.length === 0) return '';
    return sentences[Math.floor(Math.random() * sentences.length)];
};

const calculateMaxScores = (data) => {
    const maxScores = {};
    data.forEach(section => {
        let sectionMaxScore = 0;
        section.questions.forEach(question => {
            if (question.type === 'radio') {
                const maxOptionValue = Math.max(...question.options.map(opt => opt.value));
                sectionMaxScore += maxOptionValue;
            } else if (question.type === 'checkbox') {
                const sumOfCheckboxValues = question.options.reduce((acc, opt) => acc + opt.value, 0);
                sectionMaxScore += sumOfCheckboxValues;
            }
        });
        maxScores[section.title] = sectionMaxScore;
    });
    return maxScores;
};

const AssessmentForm = () => {
  const { t, i18n } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const surveyData = i18n.language === 'en' ? surveyDataEN : surveyDataTR;
  const { valuationData, updateAssessment, clearDraft} = useContext(ValuationContext);
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});
  const [totalScore, setTotalScore] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({ type: 'success', message: '' });
  const dcfAutoSubmitStarted = useRef(false);
  const maxScoresByCategory = useMemo(() => calculateMaxScores(surveyData), [surveyData]);
  const isDcfOnly = isDcfOnlyCompanyStage(valuationData.entrepreneurInfo?.stage);

  // Sayfa yüklendiğinde scroll'u en üste al
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const maxOverallScore = 3000000; 
    const questionsMap = new Map();
    const sectionMap = new Map();
    
    surveyData.forEach(section => {
      section.questions.forEach(question => {
        questionsMap.set(question.id, question);
        sectionMap.set(question.id, section.title);
      });
    });
    
    const scoresByCategory = {};
    surveyData.forEach(section => {
        scoresByCategory[section.title] = 0;
    });

    for (const questionId in answers) {
      const question = questionsMap.get(questionId);
      const answerValue = answers[questionId];
      const sectionTitle = sectionMap.get(questionId);
      
      if (question && sectionTitle) {
        if (question.type === 'checkbox' && Array.isArray(answerValue)) {
          answerValue.forEach(selectedOptionText => {
            const selectedOption = question.options.find(opt => opt.option === selectedOptionText);
            if (selectedOption) {
              scoresByCategory[sectionTitle] += selectedOption.value;
            }
          });
        } else if (question.type === 'radio') {
          const selectedOption = question.options.find(opt => opt.option === answerValue);
          if (selectedOption) {
            scoresByCategory[sectionTitle] += selectedOption.value;
          }
        }
      }
    }
    
    const newCategoryResults = {};
    let overallScore = 0;
    
    for(const title in scoresByCategory) {
        const score = scoresByCategory[title];
        const maxScore = maxScoresByCategory[title];
        const percentage = maxScore > 0 ? (score / maxScore) * 100 : 0;
        let strength;
       if (percentage >= 67) { strength = i18n.language === 'en' ? 'Strong' : 'Güçlü'; } 
        else if (percentage >= 34) { strength = i18n.language === 'en' ? 'Medium' : 'Orta'; } 
        else { strength = i18n.language === 'en' ? 'Weak' : 'Zayıf'; }
        newCategoryResults[title] = { score, percentage, strength, maxScore };
        overallScore += score;
    }

    setTotalScore(overallScore);
    const overallPercentage = maxOverallScore > 0 ? (overallScore / maxOverallScore) * 100 : 0;
    
    const resultsForContext = { 
        totalScore: overallScore, 
        overallPercentage, 
        categoryResults: newCategoryResults, 
    };
    updateAssessment(answers, resultsForContext);

  }, [answers, maxScoresByCategory, updateAssessment]);

  useEffect(() => {
    const loadDraftData = async () => {
        try {
            const token = localStorage.getItem('userToken');
            const response = await fetch('/api/drafts/step/assessment', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.exists && data.data && data.data.answers) {
                    setAnswers(data.data.answers);
                }
            }
        } catch (error) {
            console.error('Draft verisi yüklenirken hata:', error);
        }
    };

    loadDraftData();
}, []);

const saveDraft = async () => {
    setIsSaving(true);
    try {
        const token = localStorage.getItem('userToken');
        const response = await fetch('/api/drafts/save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                step: 'assessment',
                data: {
                    answers: answers,
                    results: valuationData.assessmentResults
                }
            })
        });

        if (response.ok) {
            setModalConfig({ type: 'success', message: t('assessment.saveSuccess') });
            setShowModal(true);
        } else {
            throw new Error('Kaydetme başarısız');
        }
    } catch (error) {
        console.error('Kaydetme hatası:', error);
        setModalConfig({ type: 'error', message: t('assessment.saveError') });
        setShowModal(true);
    } finally {
        setIsSaving(false);
    }
};
  const handleInputChange = (questionId, value, type) => {
    setAnswers(prevAnswers => {
      if (type === 'checkbox') {
        const currentSelection = prevAnswers[questionId] || [];
        const newSelection = currentSelection.includes(value)
          ? currentSelection.filter(item => item !== value)
          : [...currentSelection, value];
        return { ...prevAnswers, [questionId]: newSelection };
      }
      return { ...prevAnswers, [questionId]: value };
    });
  };
const handleInitialClick = () => {
      const { entrepreneurInfo, financialInputs, financialResults, assessmentAnswers, assessmentResults } = valuationData;
      if (!entrepreneurInfo || !financialInputs || !assessmentAnswers || !assessmentResults) {
          setModalConfig({ type: 'error', message: t('assessment.dataIncomplete') });
          setShowModal(true);
          return;
      }

      setShowConfirmModal(true);
  };
const proceedToSave = async () => {
      setShowConfirmModal(false); 

      
      const { entrepreneurInfo, financialInputs, financialResults, assessmentAnswers, assessmentResults } = valuationData;
      if (!entrepreneurInfo || !financialInputs || (!isDcfOnly && (!assessmentAnswers || !assessmentResults))) {
          setModalConfig({ type: 'error', message: t('assessment.dataIncomplete') });
          setShowModal(true);
          return;
      }
      const submittedAssessmentAnswers = isDcfOnly ? {} : (assessmentAnswers || {});
      const submittedAssessmentResults = isDcfOnly
          ? { totalScore: 0, overallPercentage: 0, categoryResults: {} }
          : (assessmentResults || { totalScore: 0, overallPercentage: 0, categoryResults: {} });
      
      const questionsMap = new Map();
      surveyData.forEach(section => {
          section.questions.forEach(question => {
              questionsMap.set(question.id, question);
          });
      });

      const formattedAnswers = Object.keys(submittedAssessmentAnswers).map(questionId => {
          const questionData = questionsMap.get(questionId);
          const answerValue = submittedAssessmentAnswers[questionId];
          let score = 0;
          let type = 'risk';
          let selectedSentence = '';
  
          if (questionData) {
              if (questionData.type === 'checkbox' && Array.isArray(answerValue)) {
                  let potentialExists = false;
                  let allSentences = [];
                  
                  answerValue.forEach(selectedText => {
                      const optionData = questionData.options.find(opt => opt.option === selectedText);
                      if (optionData) {
                          score += optionData.value;
                          if (optionData.type === 'potential') potentialExists = true;
                          if (optionData.sentences && optionData.sentences.length > 0) {
                              allSentences.push(...optionData.sentences);
                          }
                      }
                  });
                  
                  if (potentialExists) type = 'potential';
                  selectedSentence = getRandomSentence(allSentences);
                  
              } else if (questionData.type === 'radio') {
                  const optionData = questionData.options.find(opt => opt.option === answerValue);
                  if (optionData) {
                      score = optionData.value;
                      type = optionData.type;
                      selectedSentence = getRandomSentence(optionData.sentences);
                  }
              }
          }
          
          return {
              questionId,
              questionText: questionData ? questionData.text : 'Bilinmeyen Soru',
              answer: answerValue,
              score,
              type,
              selectedSentence
          };
      });

      const categoryResultsArray = Object.entries(submittedAssessmentResults.categoryResults || {}).map(
          ([categoryTitle, data]) => ({
              categoryTitle,
              score: data.score,
              percentage: data.percentage,
              strength: data.strength,
              maxScore: data.maxScore,
          })
      );

      const payload = {
          entrepreneurInfo,
          financialInputs,
          financialResults,
          answers: formattedAnswers,
          categoryResults: categoryResultsArray,
          totalScore: submittedAssessmentResults.totalScore,
          overallPercentage: submittedAssessmentResults.overallPercentage,
      };
      
      try {
          const token = localStorage.getItem('userToken'); 
          const response = await fetch('/api/reports/save', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(payload)
          });
  
          const data = await response.json();
  
          if (response.ok) {
              await clearDraft();
              if (isDcfOnly) {
                  navigate(`/dashboard/report/${data.reportId}`);
                  return;
              }
              setModalConfig({
                  type: 'success',
                  message: t('assessment.reportSaved'),
                  onClose: () => navigate(`/dashboard/report/${data.reportId}`)
              });
              setShowModal(true);
          } else {
              setModalConfig({ type: 'error', message: `${t('common.error')}: ${data.msg || t('assessment.serverError')}` });
              setShowModal(true);
          }
      } catch (error) {
          console.error('Kaydetme sırasında hata oluştu:', error);
          setModalConfig({ type: 'error', message: t('assessment.reportError') });
          setShowModal(true);
      }
  };

  useEffect(() => {
    if (isDcfOnly && !dcfAutoSubmitStarted.current) {
      dcfAutoSubmitStarted.current = true;
      proceedToSave();
    }
  }, [isDcfOnly]);

return (
    <div className="assessment-page">
      <Sidebar />

      {showModal && (
        <div className="modal-overlay" onClick={() => {
          setShowModal(false);
          if (modalConfig.onClose) modalConfig.onClose();
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className={`modal-icon ${modalConfig.type}`}>
              {modalConfig.type === 'success' ? '✓' : '✕'}
            </div>
            <p className="modal-message">{modalConfig.message}</p>
            <button
              className="modal-close-btn"
              onClick={() => {
                setShowModal(false);
                if (modalConfig.onClose) modalConfig.onClose();
              }}
            >
              {t('assessment.ok')}
            </button>
          </div>
        </div>
      )}

      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{maxWidth: '500px', padding: '30px'}}>
            <div className="modal-icon warning" style={{color: '#f59e0b', fontSize: '40px', marginBottom: '15px'}}>
              ⚠
            </div>
            <h3 style={{marginBottom: '15px', color: '#333'}}>{t('assessment.finalWarning.title')}</h3>
            <p className="modal-message" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: '25px', textAlign:'center'}}>
                {t('assessment.finalWarning.message')}
            </p>
            <div style={{display: 'flex', gap: '15px', justifyContent: 'center', width: '100%'}}>
                <button
                  className="modal-close-btn"
                  style={{backgroundColor: '#6b7280', flex: 1}}
                  onClick={() => setShowConfirmModal(false)}
                >
                  {t('assessment.finalWarning.cancelButton')}
                </button>
                <button
                  className="modal-close-btn"
                  style={{backgroundColor: '#10b981', flex: 1}}
                  onClick={proceedToSave}
                >
                  {t('assessment.finalWarning.confirmButton')}
                </button>
            </div>
          </div>
        </div>
      )}

      <div className="assessment-container">
        <div className="assessment-header">
          {!isDcfOnly && <div className="progress-section">
            <ProgressBar currentStep={3} />
          </div>}
          <h1>{isDcfOnly ? (i18n.language?.startsWith('en') ? 'DCF Valuation' : 'DCF Değerlemesi') : t('assessment.title')}</h1>
          <div className="intro-text">
            {isDcfOnly
              ? <p>{i18n.language?.startsWith('en') ? 'Berkus assessment is not used for this company stage. Complete your report using the DCF valuation.' : 'Bu şirket aşamasında Berkus değerlendirmesi uygulanmaz. Raporunuz DCF değerlemesiyle oluşturulacaktır.'}</p>
              : <><p>{t('assessment.intro1')}</p><p>{t('assessment.intro2')}</p></>}
          </div>
        </div>
        
        <form className="assessment-form">
          {!isDcfOnly && surveyData.map((section) => (
            <div key={section.title} className="form-section">
              <div className="section-header">
                <h2>{section.title}</h2>
              </div>
              <div className="form-section-content">
                {section.questions.map((question) => (
                  <div key={question.id} className="question-block">
                   <label className="question-label">
                    {question.text}
                    {question.tooltip && (
                        <span className="tooltip-wrapper">
                            <FiInfo className="tooltip-icon" />
                            <span className="tooltip-text">{question.tooltip}</span>
                        </span>
                    )}
                </label>
                    <div className="options-group">
                      {question.options.map((optionObject, optionIndex) => {
                        const optionId = `${question.id}-${optionIndex}`;
                        const optionText = optionObject.option;
                        return (
                          <label key={optionId} className="option-item">
                            <input
                              type={question.type}
                              id={optionId}
                              name={question.id}
                              value={optionText}
                              checked={
                                question.type === 'checkbox'
                                  ? (answers[question.id] || []).includes(optionText)
                                  : answers[question.id] === optionText
                              }
                              onChange={() => handleInputChange(question.id, optionText, question.type)}
                            />
                            <span htmlFor={optionId}>{optionText}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </form>
        
        <div className="form-navigation">
          {isDcfOnly ? <div className="nav-buttons-group">
            <button type="button" className="back-button" onClick={() => navigate('/financial-table')}>
              ← {t('assessment.previous')}
            </button>
            <button type="button" onClick={proceedToSave} className="next-button">
              {i18n.language?.startsWith('en') ? 'Create DCF Report' : 'DCF Raporunu Oluştur'} →
            </button>
          </div> : <>
                    <button
                        type="button"
                        className="save-draft-btn"
                        onClick={saveDraft}
                        disabled={isSaving}
                    >
                        {isSaving ? t('assessment.saving') : t('assessment.saveForLater')}
                    </button>

                    <div className="nav-buttons-group">
                        <button
                            type="button"
                            className="back-button"
                            onClick={() => navigate('/financial-table')}
                        >
                            ← {t('assessment.previous')}
                        </button>
                        <button
                        type="button"
                        onClick={handleInitialClick} 
                        className="next-button"
                    >
                        {t('assessment.completeAssessment')} →
                    </button>
                    </div>
          </>}
                </div>
      </div>
    </div>
  );
};

export default AssessmentForm;
